//src/app/features/conversations/Conversation/ConversationMessagesList.tsx
import Hr from 'Components/Hr';
import Spinner from 'Components/Spinner';
import LoadingSpinner from 'Components/Spinner/LoadingSpinner';
import { useLayoutEffect, useRef } from 'react';
import Message from '../Components/Message';
import { useConversation } from '../Hooks/useConversation';

export default function ConversationMessagesList() {
  const {
    addScrollOffset,
    conversation,
    messages,
    hasMoreNext,
    hasMorePrev,
    loadNext,
    loadPrevious,
    newMessageId,
    scrollToMessageId,
    conversationUsers,
  } = useConversation();

  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const scrollMessageRef = useRef<HTMLDivElement>(null);
  const scrollOffset = 64;

  const initialScroll = useRef<boolean>(true);

  useLayoutEffect(() => {
    if (!scrollContainerRef || !scrollContainerRef.current) return;

    scrollMessageRef.current?.scrollIntoView({
      block: 'start',
    });
    scrollContainerRef.current.scrollTop -=
      addScrollOffset && !initialScroll.current ? scrollOffset : 0;

    initialScroll.current = false;
  }, [messages]);

  return (
    <div
      ref={scrollContainerRef}
      className="overflow-y-scroll flex-1 flex flex-col"
    >
      {(!messages || !conversation) && <Spinner className="mt-auto mb-auto" />}
      {messages &&
        conversation &&
        messages[0].conversation_id === conversation.id && (
          <>
            <LoadingSpinner
              active={!!messages && !!hasMorePrev}
              loadMore={loadPrevious}
            />

            <div className="flex flex-col-reverse mt-auto">
              {messages
                .map((m) => ({ ...m, sender: conversationUsers[m.sender.id] }))
                .slice()
                .reverse()
                .map((message) => (
                  <div
                    key={message.id}
                    ref={
                      message.id === scrollToMessageId ? scrollMessageRef : null
                    }
                    className="flex flex-1 flex-col"
                  >
                    {message.id === newMessageId && (
                      <Hr key="new" text="New" className="text-xs" />
                    )}
                    <Message message={message} />
                  </div>
                ))}
            </div>
            <LoadingSpinner
              active={!!messages && !!hasMoreNext}
              loadMore={loadNext}
            />
          </>
        )}
    </div>
  );
}
